import { WbsItemType } from '../../../../domain/entity/WbsItemEntity'
import { WbsItemTypeVO } from '../../../../domain/value-object/WbsItemTypeVO'
import type { BaseWbsItemType } from '../../../../store/project'

// snapshot は workgroup の type を PROCESS に潰すため rootType では区別できない。
// workgroup は子になれず必ずツリー最上位 (path.length === 1) なので構造から解決する。
export const resolveSnapshotWbsItemType = (
  path: string[],
  type: WbsItemType,
  wbsItemTypes: BaseWbsItemType
): WbsItemTypeVO | undefined =>
  path.length === 1 ? wbsItemTypes.workgroup : wbsItemTypes.get(type)
